export default __webpack_public_path__ + "static/media/vivek.c4362ba2.jpg";